// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"55":"records","507":"join","540":"center","688":"good","885":"tool","962":"home","966":"login"}[chunkId] + "." + {"55":"3b4bed00","507":"7e3deb35","540":"04e84168","688":"72963f21","885":"6874e1f4","962":"8cad5c74","966":"1c940417"}[chunkId] + ".js";
};